import { useFirstModule } from "../provider/invoiceProvider";
import { Card, CardContent, styled } from "@mui/material";
import { grey } from "@mui/material/colors";
import React, { FC, useEffect, useRef, useState } from "react";
import successIconSvg from "../assets/upisuccess.svg";
import { toBlob, toPng } from "html-to-image";
// import shareSvg from "../assets/sharenew12.svg";
// import downloads from "../assets/downloadnew12.svg";
import FooterLink from "./footerLink";
// import yesbank from "../assets/yesbanknew12.svg";
import { goToCallback, goToCallbackLocation } from "../helper/usefulLinks";
import success from "../assets/successtheme4.svg";

interface successProps {
  paymentData: {
    txn_amount?: string;
    txn_status?: string;
    txn_orderid?: string;
    txn_txnid?: string;
    txn_time?: string;
    merchant_name?: string;
    merchant_email?: string;
    merchant_mobile?: string;
  };
  redirectUrl?: string | null;
}

const FifthPaymentSuccess: FC<successProps> = ({
  paymentData,
  redirectUrl,
}) => {
  const { invoiceData } = useFirstModule();
  const elementRef = useRef<HTMLDivElement | null>(null);
  const [dataUrl, setDataUrl] = useState<string>("");
  const txn_time = paymentData?.txn_time;
  const host = window.location.host;

  const htmlToImageConvert = () => {
    if (elementRef.current) {
      toPng(elementRef.current, { cacheBust: false })
        .then((dataUrl) => {
          const link = document.createElement("a");
          link.download = "Vampay_Payment.png";
          link.href = dataUrl;
          link.click();
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      console.error("elementRef.current is null");
    }
  };

  // const shareImage = () => {
  //   if (dataUrl) {
  //     fetch(dataUrl)
  //       .then((res) => res.blob())
  //       .then((blob) => {
  //         const file = new File([blob], "image.png", { type: "image/png" });

  //         if (navigator.share) {
  //           navigator
  //             .share({
  //               title: "Share Image",
  //               files: [file],
  //             })
  //             .then(() => console.log("Share successful"))
  //             .catch((error) => console.error("Error sharing:", error));
  //         } else {
  //           alert(
  //             "Your browser does not support the Web Share API. Please use another method to share the image."
  //           );
  //         }
  //       })
  //       .catch((error) => {
  //         console.error("Error creating File:", error);
  //       });
  //   } else {
  //     console.error("No data URL available");
  //   }
  // };

  // const handleShare = async () => {
  //   if (elementRef.current) {
  //     const newFile = await toBlob(elementRef.current);
  //     if (newFile) {
  //       // Add a null check here
  //       const data = {
  //         files: [
  //           new File([newFile], "image.png", {
  //             type: newFile.type,
  //           }),
  //         ],
  //         title: "Image",
  //         text: "image",
  //       };
  //       try {
  //         if (navigator && navigator.canShare && !navigator.canShare(data)) {
  //           console.error("Can't share");
  //         } else if (navigator && navigator.share) {
  //           await navigator.share(data);
  //         } else {
  //           console.error("Sharing not supported");
  //           alert("Your browser does not support Sharing");
  //           htmlToImageConvert();
  //         }
  //       } catch (err) {
  //         console.error(err);
  //       }
  //     } else {
  //       console.error("Failed to convert element to blob");
  //     }
  //   } else {
  //     console.error("elementRef.current is null");
  //   }
  // };

  const handleShare = async () => {
    if (elementRef.current) {
      const newFile = await toBlob(elementRef.current);
      if (newFile) {
        // Add a null check here
        const data = {
          files: [
            new File([newFile], "image.png", {
              type: newFile.type,
            }),
          ],
          title: "Image",
          text: "This is a payment invoice. If your browser does not support sharing, kindly download the invoice from the provided link.",
          url: `https://${host}/invoice/${invoiceData?.invoiceId}`,
        };
        try {
          if (navigator && navigator.canShare && !navigator.canShare(data)) {
            console.error("Can't share");
            alert(
              "Your browser does not support Sharing , you can download the image instead."
            );
            htmlToImageConvert();
          } else if (navigator && navigator.share) {
            await navigator.share(data);
          } else {
            console.error("Sharing not supported");
            alert(
              "Your browser does not support Sharing , you can download the image instead."
            );
            htmlToImageConvert();
          }
        } catch (err) {
          console.error(err);
          htmlToImageConvert();
        }
      } else {
        console.error("Failed to convert element to blob");
        htmlToImageConvert();
      }
    } else {
      console.error("elementRef.current is null");
      htmlToImageConvert();
    }
  };

  useEffect(() => {
    if (redirectUrl) {
      setTimeout(() => {
        goToCallbackLocation(redirectUrl);
      }, 5000);
    }
  }, []);

  return (
    <div>
      <div className="flex flex-col gap-2" ref={elementRef}>
        <div className="relative flex items-start justify-center">
          <div className=" bg-[#54AF66] w-full flex flex-col  gap-4 border-dashed  p-4 rounded-3xl mt-10 ">
            <div className="mt-10 ">
              <div className="flex items-center justify-center">
                <img src={success} height={50} width={50} />
              </div>

              <div className="mt-4 text-center text-white ">
                <p className="font-semibold text-center text-[26px]">
                  Transaction Successful
                </p>
                {paymentData.txn_time && (
                  <p className="text-center">{paymentData.txn_time} </p>
                )}
              </div>
            </div>
          </div>
        </div>
        <Card
          sx={{
            minWidth: 100,
            borderRadius: 4,
            marginY: 1,
            boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
          }}
        >
          <CardContent>
            <div className="flex flex-col items-start justify-around w-full gap-4 p-2 ">
              <p className="text-[18px] font-bold">Transaction ID</p>
              <p>{invoiceData?.order_id}</p>
            </div>
          </CardContent>
        </Card>
        <Card
          sx={{
            minWidth: 100,
            borderRadius: 4,
            marginY: 1,
            boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
          }}
        >
          <CardContent>
            <div className="flex flex-col items-start justify-around w-full gap-4 p-2 ">
              <p className="text-[18px] font-bold text-blue-600">Paid to</p>
              <div className="flex items-center">
                <div className="flex items-center justify-center w-16 h-16 rounded-lg">
                  <img
                    src={invoiceData?.merchant_logo || ""}
                    alt="logo"
                    height={100}
                    width={100}
                    className=""
                  />
                </div>
                <p className="text-[18px] font-semibold">
                  {invoiceData?.vendor_name}
                </p>
              </div>
            </div>
          </CardContent>
        </Card>
        <Card
          sx={{
            minWidth: 100,
            borderRadius: 4,
            marginY: 1,
            boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
          }}
        >
          <CardContent>
            <div className="flex items-center justify-between w-full gap-4 p-2 ">
              <p className="text-[18px] font-bold  ">Amount Paid</p>
              <p className="text-[18px] font-bold  ">
                ₹ {invoiceData?.payable_amount || "N/A"}
              </p>
            </div>
          </CardContent>
        </Card>
        <div className="">
          <Card
            sx={{
              minWidth: 275,
              borderRadius: 4,
              background: "#5A5CE7",
              boxShadow: "inset 0 0 5px rgba(0, 0, 0, 0.5)",
            }}
            className="w-full bg-[#E95400] mt-4 hover:bg-[#6149D3]"
          >
            <CardContent className="flex items-center justify-center ">
              <button
                onClick={handleShare}
                className="flex items-center justify-center gap-4 "
              >
                {/* <img
                src={shareSvg}
                alt="logo"
                height={25}
                width={25}
                className=""
              /> */}
                <p className="text-white">Share Invoice</p>
              </button>
            </CardContent>
          </Card>

          <Card
            sx={{
              minWidth: 275,
              borderRadius: 4,
              background: "#5A5CE7",
              boxShadow: "inset 0 0 5px rgba(0, 0, 0, 0.7)",
            }}
            className="w-full bg-[rgb(52,168,83)] mt-4 hover:bg-[#6149D3]"
          >
            <CardContent className="flex items-center justify-center ">
              <button
                onClick={htmlToImageConvert}
                className="flex items-center justify-center gap-4"
              >
                {/* <img
                src={downloads}
                alt="logo"
                height={25}
                width={25}
                className=""
              /> */}
                <p className="text-white">Download Invoice</p>
              </button>
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default FifthPaymentSuccess;
